import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Label from '../Label/Label';
import ErrorLabel from '../ErrorLabel/ErrorLabel';

const InputWrapper = styled.div`
  input {
    margin: 0;
    padding: 0;
    border-radius: 6px;
    border: solid 2px var(--input-border-color);
    background-color: var(--input-background-color);
    font-size: 16px;
    font-family: 'OpenSans', sans-serif;
    font-weight: normal;
    color: var(--input-color);
    padding: var(--quarter-spacing-unit) var(--half-spacing-unit);
    width: 100%;
  }
  width: 100%;
`;

const Input = ({
  label,
  style,
  type,
  placeholder,
  onChange,
  onClick,
  value,
  testId,
  maxlength,
  error,
  onBlur,
  autofocus,
  disabled,
}) => (
  <InputWrapper>
    {label ? (
      <Label data-testid={testId && `${testId}-input-label`}>{label}</Label>
    ) : (
      ''
    )}
    <input
      autoFocus={autofocus ? 'autofocus' : undefined}
      type={type}
      placeholder={placeholder}
      style={style}
      onChange={onChange}
      onClick={onClick}
      value={value}
      data-testid={testId && `${testId}-input`}
      maxLength={maxlength}
      className={error ? 'inputError' : undefined}
      onBlur={onBlur}
      disabled={disabled}
    />
    <ErrorLabel error={error} />
  </InputWrapper>
);

Input.defaultProps = {
  label: '',
  style: {},
  type: 'text',
  placeholder: '',
  onChange: () => {},
  onClick: undefined,
  value: undefined,
  testId: undefined,
  maxlength: undefined,
  onBlur: undefined,
  error: '',
  autofocus: false,
  disabled: false,
};

Input.propTypes = {
  label: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testId: PropTypes.string,
  maxlength: PropTypes.number,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  autofocus: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Input;
